document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-pdp-root]');
  if (!root) return;

  const productJsonEl = root.querySelector('[data-pdp-product-json]');
  const product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;

  const select = root.querySelector('select[name="id"]');
  const tiles = Array.from(root.querySelectorAll('[data-variant-id]'));

  const priceEl = root.querySelector('[data-pdp-price]');
  const compareEl = root.querySelector('[data-pdp-compare]');
  const atcBtn = root.querySelector('[data-pdp-atc]');
  const mainImg = root.querySelector('#pdp-main-img');

   const moneyFormatEl = root.querySelector('[data-money-format]');
  const moneyFormat = moneyFormatEl ? moneyFormatEl.getAttribute('data-money-format') : '${{amount}}';

  const money = (cents) => {
    // Shopify-native formatting if available
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    // Fallback (should rarely be used)
    const n = (cents ?? 0) / 100;
    return n.toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  };

  const findVariant = (id) => {
    if (!product?.variants) return null;
    return product.variants.find(v => String(v.id) === String(id)) || null;
  };

  function setActiveTileById(variantId){
    tiles.forEach(t => t.setAttribute('aria-pressed', String(t.dataset.variantId === String(variantId))));
  }

  function updateUrl(variantId){
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch(e){}
  }

  function updateUIFromVariant(variant){
    if (!variant) return;

    // Price
    if (priceEl) priceEl.textContent = money(variant.price);

    // Compare-at
    if (compareEl){
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (hasCompare){
        compareEl.style.display = '';
        compareEl.textContent = money(variant.compare_at_price);
      } else {
        compareEl.style.display = 'none';
      }
    }

    // ATC state
    if (atcBtn){
      if (variant.available){
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to cart';
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold out';
      }
    }

    // Main image swap (if variant has featured_media)
    if (mainImg && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src){
      // Shopify JSON gives a full URL to the image
      mainImg.src = variant.featured_media.preview_image.src;
    }

    updateUrl(variant.id);
    setActiveTileById(variant.id);
  }

  // Wire tiles -> select -> UI updates
  if (select && tiles.length){
    const initialVariant = findVariant(select.value);
    updateUIFromVariant(initialVariant);

    tiles.forEach(tile => {
      tile.addEventListener('click', () => {
        const id = tile.dataset.variantId;
        select.value = id;
        select.dispatchEvent(new Event('change', { bubbles: true }));

        const v = findVariant(id);
        updateUIFromVariant(v);
      });
    });

    select.addEventListener('change', () => {
      const v = findVariant(select.value);
      updateUIFromVariant(v);
    });
  }

  // Qty stepper
  const qtyWrap = root.querySelector('[data-qty]');
  if (qtyWrap){
    const input = qtyWrap.querySelector('input');
    const dec = qtyWrap.querySelector('[data-dec]');
    const inc = qtyWrap.querySelector('[data-inc]');

    const clamp = (v) => Math.max(1, Math.min(999, v));

    dec?.addEventListener('click', () => {
      input.value = clamp((parseInt(input.value || '1', 10) || 1) - 1);
    });

    inc?.addEventListener('click', () => {
      input.value = clamp((parseInt(input.value || '1', 10) || 1) + 1);
    });
  }
});